import React, { useMemo, useState } from "react";
import { Form, Tab, Tabs } from "react-bootstrap";
import { LocalUser } from "@preveil-api";
import { GetLocalAccountListApiResponse, useGetLocalAccountListQuery } from "src/common/api/crypto/crypto-rtk-api";
import { PageHeader } from "src/components";
import { AddExistingUserForm, AddNewUserForm, DefaultCreateOrgForm } from ".";

function OrganizationComponent() {
  const [selected_user, setSelectedUser] = useState<LocalUser | undefined>();
  const [active_tab, setActiveTab] = useState("first");
  const { data, isLoading } = useGetLocalAccountListQuery();
  const admin_users = useMemo(() => data ? filterAdminUsers(data) : [], [data]);
  const non_org_users = useMemo(() => data ? data.users.filter(user => !user.org_info?.org_id) : [], [data]);

  function filterAdminUsers(data: GetLocalAccountListApiResponse) {
    const users = data?.users || [];
    const seen = new Set();
    
    return users
      .filter(user => 
        user?.org_info?.org_id &&
        user?.org_info?.role === "admin" &&
        !seen.has(user.org_info.org_id) &&
        seen.add(user.org_info.org_id)
      );
  }

  return (
    <div>
      <PageHeader>
        <h1>Organization</h1>
      </PageHeader>
      <Form.Group className="mb-3">
        <Form.Select
          onChange={(e) => {
            setActiveTab('first');
            setSelectedUser(admin_users.find(user => user.org_info?.org_id === e.target.value));
          }}
          disabled={isLoading}
          value={selected_user?.org_info?.org_id}
        >
          <option value="">Create an organization</option>
          {admin_users.map((user) => (
            <option 
              key={user.org_info?.org_id} 
              value={user.org_info?.org_id}
            >
              {user.org_info?.org_name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      {selected_user ? (
        <Tabs activeKey={active_tab} onSelect={key => setActiveTab(key || 'first')}>
          <Tab eventKey="first" title="Existing Users">
            <AddExistingUserForm admin_user={selected_user} account_list={non_org_users} />
          </Tab>
          <Tab eventKey="second" title="New Users">
            <AddNewUserForm admin_user={selected_user} />
          </Tab>
        </Tabs>
      ) : (
        <Tabs activeKey={active_tab} onSelect={key => setActiveTab(key || 'first')}>
          <Tab eventKey="first" title="Quick Start">
            <DefaultCreateOrgForm />
          </Tab>
        </Tabs>
      )}
    </div>
  );
}

export default React.memo(OrganizationComponent);
